import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import ContinueFooter from '../../components/ContinueFooter';

class Video extends Component {

  static propTypes = {
    onFinishVideo: PropTypes.func.isRequired,
  };

  state = {
    finished: false,
  };

  handleVideoEnded = () => this.setState({
    finished: true,
  });

  render() {
    return (
      <div>
        <ReactPlayer
          width="960px"
          height="540px"
          url="https://portonefive.wistia.com/medias/n7ozoqiq07"
          onEnded={this.handleVideoEnded}
        />
        <ContinueFooter
          continueLabel="Continue to Post-Test"
          onContinue={this.props.onFinishVideo}
          disableContinue={!this.state.finished}
        >
          <span style={{ color: '#aaa' }}>You must complete the video in order to continue.</span>
        </ContinueFooter>
      </div>
    );
  }
}

export default Video;


// WEBPACK FOOTER //
// ./src/containers/Video/index.js